import { useState } from 'react';

export default function useDebounce<T extends (...args: A) => void, A extends unknown[]>(func: T, delay = 200) {
  const [timer, setTimer] = useState<number | null>(null);
  return (...args: A) => {
    clearTimeout(timer ?? 0);
    const _temp = setTimeout(() => {
      func(...args);
    }, delay) as unknown as number;
    setTimer(_temp);
  };
}
